export const SET_HOME = 'SET_HOME'
export const SET_CURRENTSCENE = 'SET_CURRENTSCENE'
export const SET_TRANSITIONING = 'SET_TRANSITIONING'
export const SET_HOMENAVIN = 'SET_HOMENAVIN'
export const SET_ANIMRIGHT = 'SET_ANIMRIGHT'
export const SET_INFOCARDIN = 'SET_INFOCARDIN'
export const SET_LOCALE = 'SET_LOCALE'
export const SET_BREAKPOINT = 'SET_BREAKPOINT'
